export default __webpack_public_path__ + "static/media/fsnap.5bb51d89.png";